export const DPA_GREEN = "#aed299";
export const SETTINGS_APPBAR = "#9e9e9e";

export const THEME_BTN = {
  exact: true,
  depressed: true
};

export const THEME_BTN_PRIMARY = {
  ...THEME_BTN,
  color: "primary"
};

export const THEME_BTN_SECONDARY = {
  ...THEME_BTN,
  color: "grey lighten-3",
  class: "grey--text text--darken-1"
};

export const THEME_BTN_TERTIARY = {
  ...THEME_BTN,
  color: "white",
  class: "grey--text text--darken-1"
};

export const THEME_BTN_DETAIL_ACTION = {
  ...THEME_BTN_TERTIARY,
  color: "transparent",
  class: "black--text"
};

export const THEME_PROGRESS = {
  size: 24,
  indeterminate: true,
  class: "u-colorBlue"
};

export const THEME_DATE_FORMAT = "D. MMMM YYYY";

export const DATE_FORMAT_ISO = "YYYY-MM-DD";

export const THEME_DATE_FORMAT_SHORT = "D. MMM YY";

export const THEME_MONTH_FORMAT = "MMMM YYYY";

export default {
  THEME_BTN_PRIMARY,
  THEME_BTN_SECONDARY
};
